module.exports = __webpack_public_path__ + "static/media/question.8adcca21.png";